import { ImgHTMLAttributes } from 'react';
import { getSportIconSrc, getSportIconSvgSrc } from 'helpers/sportIcon';
import { readAppliedPlayerTheme, usesLogoTheme } from 'lib/playerTheme';
import type { ThemeIconTone } from './iconUtils';

type SportIconProps = Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'> & {
  sportId?: number | string | null;
  tone?: ThemeIconTone;
};

export function SportIcon({
  sportId,
  alt = '',
  className,
  tone = 'content',
  ...imgProps
}: SportIconProps) {
  const theme = readAppliedPlayerTheme();
  const src = usesLogoTheme(theme)
    ? getSportIconSrc(sportId)
    : getSportIconSvgSrc(sportId, tone);

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      data-theme-icon="sport"
      {...imgProps}
    />
  );
}
